import styled from "@emotion/styled";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { COLOR_GREY_11, COLOR_GREY_3, COLOR_GREY_8 } from "shared/theme/colors";

export const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    min-width: 200px;
    height: 40px;
    border-radius: 0.5rem;
    background-color: ${COLOR_GREY_3};
    color: ${COLOR_GREY_11};

    &:before {
      border-bottom: 0;
    }

    &:after {
      border-bottom: 0;
    }

    &:hover:not(.Mui-disabled):before {
      border-bottom: 0;
    }
  }
`;

export const StyledIconWrapper = styled(InputAdornment)`
  svg > path {
    fill: ${COLOR_GREY_8};
  }
`;
